/**
 * @fileoverview A component that ensures that only authenticated users can access the content.
 * It uses the `useUserAPI` hook to check if the user is authenticated.
 *
 * @example
 * <ProtectedRoute><div>Authenticated content</div></ProtectedRoute>
 */

import { PropsWithChildren } from 'react'
import { useUserAPI } from '../hooks/useUserAPI'

/**
 * @interface ProtectedRouteProps
 * @description Props for the ProtectedRoute component.
 * @property {React.ReactNode} children - The content to be protected.
 */
export function ProtectedRoute({ children }: PropsWithChildren) {
    const { getUser } = useUserAPI()
    const user = getUser()

    if (!user) {
        return null
    }

    return <>{children}</>
}
